import { useMemo } from 'react';

import { getDetails } from 'components/Blog/getDetails';
import { GridContainer } from 'components/Container';
import { PreviewCard } from './PreviewCard';

import type { FC } from 'react';
import type { BlogPost } from 'types/blog/blogPost';

export const BlogPreviewCards: FC<{
  entries: BlogPost[];
}> = ({ entries }) => {
  const cards = useMemo(
    () =>
      entries.map(entry => {
        const details = getDetails({
          author: entry.author,
          date: entry.date,
        });

        return (
          <PreviewCard
            key={entry.id}
            categories={entry.categories}
            subtitle={details}
            urlSlug={entry.urlSlug}
            title={entry.title}
            description={entry.description}
            image={entry.image}
          />
        );
      }),
    [entries]
  );

  return (
    <GridContainer columns={3} gap={5} verticalAlign="top">
      {cards}
    </GridContainer>
  );
};
